import { gql, useQuery } from '@apollo/client';
import { ScatterChart } from '@mui/x-charts/ScatterChart';
import Loader from '../../../genericComponents/Loader';
import { DateTime } from "luxon";
import { Box, useTheme,Chip } from '@mui/material';
import { useRef, useState } from 'react';
import TotalChart from './FullTotalCard';
import DownloadMenu from './DownloadMenu';

const ScatterPlot = ({ id, level,start,end, meterType, height }) => {
  const [selectedDate,setSelectedDate]=useState(null);
    const GET_SCATTERPLOT = `query getScatterPlot($id:UUID!,$level:Level!,$meterType:MeterType!,$start:DateTime!,$end:DateTime!,$temperatureLevel:TemperatureRange!)
{
  scatterPlot(chartInput:{id:$id,level: $level,meterType: $meterType,start: $start,end: $end},level:$temperatureLevel){
    temperature
    value
    date
  }}`;
  const ref=useRef();
  const [activePill, setActivePill] = useState(0);
  const theme=useTheme();
  const temperatureLevel=activePill==0?"HOUR":"DAY";
    const { data, loading, error } = useQuery(gql(GET_SCATTERPLOT),
        { variables: { id: id, level: level, meterType: meterType, start: start,end:end,temperatureLevel:temperatureLevel } });
        const pills=(
<Box sx={{ display: "flex", marginRight: theme.spacing(1), justifyContent: 'flex-end', width: "100%" }}>
          <DownloadMenu graph={ref} type="TemperatuurData" data={data?.scatterPlot}/>                
</Box>    

        )
    if (loading || !data) {
        return(
          <Box sx={{display:"flex",flexDirection:"column",height:"100%"}}>
            {pills}
        <Loader height={height} text={"Loading Data"} />
        </Box>)
    }
    const unit = meterType=="GAS" ? " m3" : " kWh";
    
    // Filter out invalid data points
    const validScatterData = data.scatterPlot.filter(item => 
        item && item.temperature !== null && item.temperature !== undefined && item.value !== null && item.value !== undefined
    );
    
    const series = [{ 
        label: "Date",
        color: theme.palette.secondary.main,
        valueFormatter: (v) => {return (v === null ? '' : DateTime.fromISO(v.id).toLocaleString())},
        data: validScatterData.map(item => ({ x: item.temperature, y: item.value, id: item.date })),
        color: theme.palette.secondary.main 
    }];
      const onItemClick = (event,params) => {
        const item=series[0].data[params.dataIndex];
        const date=DateTime.fromISO(item.id);
        setSelectedDate(date);
      };
      if(selectedDate){        
        return <TotalChart id={id} level={level} meterType={meterType} height={height} start={selectedDate} groupLevel={"HOUR"} end={selectedDate} onTopLevelClick={()=>setSelectedDate(null)} />
      }
    return (
      <Box sx={{display:"flex",flexDirection:"column",height:"100%"}}>
          {pills}        
        <ScatterChart
        ref={ref}
        onItemClick={onItemClick}
        height={height}
        margin={{ left: 100, right: 120, bottom: 100 }}
        yAxis={[
            {
                valueFormatter: (value, context) =>
                    value+unit
            }
          ]}
        series={series}
        />        
        </Box>
    );
}
export default ScatterPlot;